import { Modal, Form, Input, Card, Checkbox } from "antd"
import { CustomBtn } from "../../../../components/commonComponents"
import { addUser, updateUser } from "../actions";
import { useEffect } from "react";

export default function UserModal({open, close, data, reload}) {
    const [form] = Form.useForm();
    const onFinish = (values) => {
        if (data) {
            updateUser(values, data.id).then(res => {
                reload()
                console.log(res)
                close(false)
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                reload()
            })
        } else {
            addUser(values).then(res => {
                reload()
                console.log(res)
                close(false)
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                reload()
            })
        }
    }

    useEffect(() => {
        if (data) {
            form.setFieldsValue(data)
        }
    }, [data])
    return(
        <Modal
        onClose={form.resetFields}
        title={data ? "მომხმარებლის რედაქტირება" : "მომხმარებლის დამატება"} 
        open={open} 
        footer={[
            <CustomBtn key="submit" label="დამატება" onClick={form.submit} color="green" icon={<i className="fa-solid fa-circle-plus"></i>} colorHover={'#135200'} htmlType="submit" />,
            <CustomBtn key="cancel" label="დახურვა" onClick={() => {
                close(false)
                form.resetFields()
            }} color="gray" icon={<i className="fa-solid fa-circle-xmark"></i>} colorHover={'#000'} />
        ]}
        onCancel={() => {
            form.resetFields()
            close(false)}
            }>
            <Card>
            <Form 
            form={form} 
            onFinish={onFinish} 
            layout="vertical"
                  >
                <Form.Item 
                label="Email" 
                name="email"
                rules={[
                    {required: true, message: 'Email სავალდებულოა'},
                    {type: 'email', message: 'მითითეთ ვალიდური ელ.ფოსტა'},
                ]}
                >
                    <Input autoComplete="none" />
                </Form.Item>
                <Form.Item label="პაროლი" name="password"
                rules={[
                    {required: true, message: 'პაროლი სავალდებულოა'},
                    {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/, message: 'პაროლი უნდა შეიცავდეს მცირე და დიდ ალოებს, ციფრებს, სიმბოლოებს და უნდა იყოს მინიმუმ 8 სიმბოლო'},
                    // {min: 8, message: 'პაროლი უნდა იყოს მინიმუმ 8 სიმბოლო'},
                    {max: 16, message: 'პაროლი უნდა იყოს მაქსიმუმ 16 სიმბოლო'},
                ]}  
                >
                    <Input.Password autoComplete="off" />
                </Form.Item>
                <Form.Item 
                label="გაიმეორეთ პაროლი" 
                name="confirm_password"
                dependencies={['password']}
                rules={[
                    {required: true, message: 'პაროლი სავალდებულოა'},
                    {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/, message: 'პაროლი უნდა შეიცავდეს მცირე და დიდ ალოებს, ციფრებს, სიმბოლოებს და უნდა იყოს მინიმუმ 8 სიმბოლო'},
                    {max: 16, message: 'პაროლი უნდა იყოს მაქსიმუმ 16 სიმბოლო'},
                    ({getFieldValue}) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('პაროლები არ ემთხვევა'));
                        },
                    }),
                ]}
                >
                    <Input.Password autoComplete="off" />
                </Form.Item>
                <Form.Item
                 label="Admin" name="is_admin" 
                 valuePropName="checked"
                 initialValue={false}
                 >
                    <Checkbox />
                </Form.Item>    
            </Form>
            </Card>
        </Modal>
    )
}